import Rollbar from 'rollbar'

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.NODE_ENV,
    source_map_enabled: true,
  },
}
const rollbar = new Rollbar(rollbarConfig)
rollbar.global({ maxItems: 25 })

export default rollbar
